import { render, staticRenderFns } from "./ImportQues.vue?vue&type=template&id=5c1bedd0"
import script from "./ImportQues.vue?vue&type=script&lang=js"
export * from "./ImportQues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c1bedd0')) {
      api.createRecord('5c1bedd0', component.options)
    } else {
      api.reload('5c1bedd0', component.options)
    }
    module.hot.accept("./ImportQues.vue?vue&type=template&id=5c1bedd0", function () {
      api.rerender('5c1bedd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/mentalHealth/MindEvaluation/components/ImportQues.vue"
export default component.exports